module.exports = __webpack_public_path__ + "img/plus.94f76ae.png";